import { BRAND_LOCALES_MAP, } from '../../types/index.js';
import { parseLocaleOrLang } from './parse-locale.js';
import merge from 'ts-deepmerge';
export const buildMergedPackage = (translationsByPackage) => {
    const translationsForPackages = translationsByPackage
        .flatMap((item) => (item ? [item] : []))
        .map(({ packageName, packageTranslation }) => {
        if (!packageTranslation?.base) {
            throw Error(`Unable to process ${packageName} translation, base is not defined in translation.json`);
        }
        return buildTranslationForPackage(packageName, packageTranslation, BRAND_LOCALES_MAP);
    });
    return translationsForPackages.reduce((prev, curr) => {
        return prev ? merge(prev, curr) : curr;
    }, {});
};
export const buildTranslationForPackage = (packageName, allTranslations, supportedBrands) => {
    const brands = Object.entries(supportedBrands).map(([brand, locales]) => {
        const translationPerLocale = locales.map((locale) => {
            return {
                [locale]: {
                    [packageName]: mergeForLocale(allTranslations, brand, locale),
                },
            };
        });
        const translationPerBrand = translationPerLocale.reduce((prev, curr) => ({ ...prev, ...curr }), {});
        return {
            [brand]: translationPerBrand,
        };
    });
    return brands.reduce((prev, curr) => ({ ...prev, ...curr }), {});
};
const mergeForLocale = (translationForPackage, brand, locale) => {
    const { lang } = parseLocaleOrLang(locale);
    const mergedBase = merge(translationForPackage.base[lang] || {}, translationForPackage.base[locale] || {});
    if (!translationForPackage.brand?.[brand]) {
        return mergedBase;
    }
    return merge(mergedBase, translationForPackage.brand[brand][lang] || {}, translationForPackage.brand[brand][locale] || {});
};
//# sourceMappingURL=merge-translations.js.map